(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	Voonto.getInstance().define(['module'], function (module) {
	  return {
	    wakeUp: function wakeUp($elm) {
	      Logger.info('wake up module ' + module.id);
	      var app = Voonto.getInstance();
	
	      var outbrainCodes = app.lookup('vocento.config.nibara').outbrainCodes;
	      if (outbrainCodes === undefined) {
	        throw 'nibara outbrainCodes config is empty';
	      }
	
	      var template = 'vocentoes';
	      Logger.info('[outbrain] template: ' + template);
	
	      // wait to finish document load
	      Voonto.$(document).ready(function () {
	        Logger.info('[outbrain] DOM load finished continue loading outbrain widgets');
	
	        outbrainCodes.split(',').forEach(function (widget) {
	          Logger.info('[outbrain] append widget with code: ' + widget);
	          $elm.append('<div class="OUTBRAIN" data-src="' + document.URL + '" data-widget-id="' + widget + '" data-ob-template="' + template + '"></div>');
	        });
	        app.load('//widgets.outbrain.com/outbrain.js').then(function () {
	          Logger.info('[outbrain] call to outbrain success');
	          setTimeout(function () {
	            Logger.info('[Sticky] call to outbrain success');
	            app.trigger('layout:recalc-sticky');
	          }, 1000);
	        }, function (error) {
	          Logger.error('[outbrain] call to outbrain rejected ' + error);
	          Logger.info('[Sticky] call to outbrain rejected ' + error);
	          app.trigger('layout:recalc-sticky');
	        });
	      });
	    }
	  };
	});

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// outbrain-module.js